import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const paymentLinksUri = config.apiEndpoints.paymentLinksUri
export default {
    findAll: (keywords, sellerId, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                page: page,
                pageSize: pageSize,
                keywords: keywords,
                sellerId: sellerId
            }
            HTTP.get(paymentLinksUri.concat('search'), {params: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(paymentLinksUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(paymentLinksUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(paymentLinksUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(paymentLinksUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}